
import { VoiceConfig } from './voiceUtils';

export interface VoicePreset {
  id: string;
  name: string;
  description: string;
  config: {
    customCommands: string;
    customResponses: string;
  };
}

export const voicePresets: VoicePreset[] = [
  {
    id: 'basic',
    name: 'Basic Navigation',
    description: 'Simple navigation commands for essential website functions',
    config: {
      customCommands: JSON.stringify({
        'open menu': 'toggleMenu',
        'close menu': 'closeMenu',
        'go back': 'goBack'
      }, null, 2),
      customResponses: JSON.stringify({
        'help': 'I can help you navigate the website. Try saying "open menu" or "go back".',
        'notFound': 'I couldn\'t understand that command. Try asking for help.'
      }, null, 2)
    }
  },
  {
    id: 'accessibility',
    name: 'Accessibility Focus',
    description: 'Enhanced commands for accessibility features',
    config: {
      customCommands: JSON.stringify({
        'increase text': 'increaseFontSize',
        'decrease text': 'decreaseFontSize',
        'toggle dark mode': 'toggleDarkMode',
        'enable high contrast': 'enableHighContrast',
        'disable high contrast': 'disableHighContrast'
      }, null, 2),
      customResponses: JSON.stringify({
        'help': 'I can help you adjust accessibility settings. Try saying "increase text" or "toggle dark mode".',
        'notFound': 'I couldn\'t find that setting. Try asking for help to see available commands.',
        'confirmed': 'Settings updated successfully.'
      }, null, 2)
    }
  },
  {
    id: 'comprehensive',
    name: 'Comprehensive Control',
    description: 'Full set of navigation and accessibility commands',
    config: {
      customCommands: JSON.stringify({
        'open menu': 'toggleMenu',
        'close menu': 'closeMenu',
        'go back': 'goBack',
        'scroll down': 'scrollDown',
        'scroll up': 'scrollUp',
        'increase text': 'increaseFontSize',
        'decrease text': 'decreaseFontSize',
        'toggle dark mode': 'toggleDarkMode',
        'search for': 'initiateSearch'
      }, null, 2),
      customResponses: JSON.stringify({
        'help': 'I can help you navigate and control the website. Try commands like "scroll down", "increase text", or "toggle dark mode".',
        'notFound': 'I couldn\'t understand that command. Try asking for help to see all available options.',
        'confirmed': 'Command executed successfully.',
        'searchPrefix': 'Searching for'
      }, null, 2)
    }
  }
];

